// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.messaging.CreateMessageParticipantRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateMessageParticipantRequest extends GandalfModelBase {

	@GandalfLabel('Message Participant External Address')
	@GandalfValidator({ sizeString: { message: 'Message Participant External Address cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	externalAddress!: string | null;

	@GandalfLabel('Message Participant Person')
	@GandalfProperty({ designType: Number })
	personId!: number | null;

}
